__turbopack_context__.v({
  "backdrop": "modal-module-scss-module__jOrrFa__backdrop",
  "backdrop-show": "modal-module-scss-module__jOrrFa__backdrop-show",
  "fade-in-uboa5cb": "modal-module-scss-module__jOrrFa__fade-in-uboa5cb",
  "icon": "modal-module-scss-module__jOrrFa__icon",
  "modal": "modal-module-scss-module__jOrrFa__modal",
  "wrapper": "modal-module-scss-module__jOrrFa__wrapper",
  "wrapper-show": "modal-module-scss-module__jOrrFa__wrapper-show",
});
